import React, {FC} from "react"
import styled from "styled-components"
import authentication from "@irati/auth"
import {FormattedCurrency} from "@irati/utils/lang"
import {WALLET} from "@irati-tracking/tracker/products"
import History, {appOrContext, useAppRouteContext} from "@irati/utils/history"
import {walletTracking} from "@irati-tracking/wallet"
import Loading from "@irati/ui/src/Loading"
import {useHeaderWallet} from "../utils/wallet"
import {WALLET_MENU_CONTEXT} from "./const"

const StyledMenu = styled.div`
  background-color: ${({theme}) => theme.colors.utility.highlight};
  color: ${({theme}) => theme.colors.greys.black};
  font-weight: bold;
  border-radius: 10px;
  padding: 5px 10px;
  margin-left: ${({theme}) => theme.spacing.one};
`

interface MobileWalletMenuProps {
  togglePanel: (key?: string) => void
}

const MobileWalletBalance: FC<MobileWalletMenuProps> = ({togglePanel}) => {
  const {app} = useAppRouteContext()
  const {load, data} = useHeaderWallet()

  if (!data?.currency) return null

  return (
    <Loading useLoader={false} load={load}>
      {data?.currency && (
        <StyledMenu
          id="mobile-balance-menu"
          onClick={() => {
            // has manager wallets
            if (authentication.apps("wallet.flexiRewards.canRewardEmployees") || authentication.apps("wallet.rewardWallet")) {
              // If multiple wallets are enabled, the dropdown menu for wallets must be displayed
              togglePanel(WALLET_MENU_CONTEXT)
            } else {
              walletTracking.clickWalletBalance(app, data.balance, data.currency, "header")
              History.push(appOrContext({to: "/", app: WALLET}, ""))
            }
          }}>
          <FormattedCurrency fontSize={18} value={data.balance} currency={data.currency} />
        </StyledMenu>
      )}
    </Loading>
  )
}

export default MobileWalletBalance
